import request from '@/utils/requestManager'

export function login(data) {
  return request({
    url: '/mobile/manager/user/login',
    method: 'post',
    data
  })
}

export function logout(data) {
  return request({
    url: '/mobile/manager/user/exit',
    method: 'post',
    data
  })
}

export function getInfo(data) {
  return request({
    url: '/mobile/manager/user/info',
    method: 'post',
    data
  })
}

export function updatePassword(data) {
  return request({
    url: '/mobile/manager/update/password',
    method: 'post',
    data
  })
}

export function getTeacherList(data) {
  return request({
    url: '/mobile/manager/teacher/list',
    method: 'post',
    data
  })
}

export function getTeacherDetail(data) {
  return request({
    url: '/mobile/manager/teacher/detail',
    method: 'post',
    data
  })
}

export function searchStudentClass(data) {
  return request({
    url: '/mobile/manager/search/student/classes',
    method: 'post',
    data
  })
}

export function saveTeacherTime(data) {
  return request({
    url: '/mobile/manager/student/times/save',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/mobile/manager.js